var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1067 -1069)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067 1069)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14,
    cy: 14,
    r: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7018.866,723.335a3.9,3.9,0,1,0,3.9,3.9A3.9,3.9,0,0,0,7018.866,723.335Zm0,6.575a2.673,2.673,0,1,1,2.673-2.673A2.674,2.674,0,0,1,7018.866,729.91Zm6.221,2.994h-12.443a1.768,1.768,0,0,1-1.766-1.766v-7.8a1.768,1.768,0,0,1,1.766-1.766h12.443a1.768,1.768,0,0,1,1.766,1.766v7.8A1.768,1.768,0,0,1,7025.087,732.9Zm-8.641-11.622h-3.87a.482.482,0,1,1,0-.963h3.87a.482.482,0,0,1,0,.963Z",
    transform: "translate(-5938.028 356.505)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.b5f558f7bef73b92d52f77c1feb874d5.svg";
export { ForwardRef as ReactComponent };